import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import Checkbox from 'ext-ui/components/Checkbox/Checkbox'
import React from 'react'
import Box from 'src/components/Box/Box'
import FieldLabel from 'src/components/FieldLabel/FieldLabel'
import Trns, { useTranslate } from 'src/localization/Trns'
import { css } from 'styled-components'

interface ExactPayBoxProps {
  isSelected?: boolean
  tooltip?: React.ReactElement
  onClick?: () => void
}

const ExactPayBox: React.FC<ExactPayBoxProps> = (props): React.ReactElement => {
  const translate = useTranslate()
  return (
    <Box>
      <FieldLabel>
        <Trns source={'Exact Pay'} />
      </FieldLabel>
      {props.tooltip !== undefined && props.tooltip}
      <div
        className="flex-row align-center gap-2"
        // AI tried to use mt-5 for this value but it does not exist
        // Reverting to regular old css here
        css={css`
          margin-top: 20px;
        `}
      >
        <Checkbox
          id="exact-pay-checkbox"
          data-testid="exact-pay-checkbox"
          checked={props.isSelected !== undefined ? props.isSelected : false}
          onChange={props.onClick}
          aria-label={translate('Transaction amount must match credit limit')}
        />
        <label
          htmlFor="exact-pay-checkbox"
          css={css`
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};
            cursor: pointer;
          `}
        >
          <Trns source={'Transaction amount must match credit limit'} />
        </label>
      </div>
    </Box>
  )
}

export default ExactPayBox
